export const packagedProductManufacturers = [
  'Chart',
  'Cryofab',
  'Linde',
  'Luxfer',
  'MVE',
  'Praxair',
  'Other (see comments)',
];

export const packagedProductHeaterOptions = [
  { value: null, label: '' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: 'NA', label: 'N/A' },
];

export const packagedProductHeightOptions = [
  { value: null, label: '' },
  { value: 'Short', label: 'Short' },
  { value: 'NA', label: 'N/A' },
  { value: 'Tall', label: 'Tall' },
];
